import { useEffect, useState } from "react";
import { Image } from "@/components/ui/image";
import { heroSlides } from "@/data/content";

/** A lightweight, accessible hero slideshow with a stable first-frame LCP. */
export default function HeroSlideshow() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (heroSlides.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % heroSlides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="relative h-full w-full">
      {heroSlides.map((slide, i) => i === index ?
      <div key={slide.src} aria-hidden={false} className="absolute inset-0 animate-[yts-hero-fade_700ms_ease-out]">
          {/* Keep only the active photograph in the DOM. The first frame is
            prioritized for LCP; later frames are requested when selected. */}
          {i === 0 ?
        <img
          src={slide.src}
          sizes="100vw"
          width="1200"
          height="675"
          alt={slide.alt}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          style={slide.focus ? { objectPosition: `${slide.focus.x * 100}% ${slide.focus.y * 100}%` } : undefined}
          className="w-full h-full object-cover saturate-[0.95]" /> :


        <Image
          src={slide.src}
          alt={slide.alt}
          fittingType="fill"
          focalPointX={slide.focus?.x}
          focalPointY={slide.focus?.y}
          loading="lazy"
          decoding="async"
          quality={78}
          style={slide.focus ? { objectPosition: `${slide.focus.x * 100}% ${slide.focus.y * 100}%` } : undefined}
          className="w-full h-full object-cover saturate-[0.9]" />

        }
        </div> :
      null)}

      














      
    </div>);

}